{
	"title": "Confirmation required",
	"cancel": "Cancel",
	"ok": "Ok"
}
